var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuSearchLine = function SvgMenuSearchLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.125 6.75a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25M11 9.375a4.125 4.125 0 1 1 7.524 2.338l2.006 2.007-1.06 1.06-2.007-2.006A4.125 4.125 0 0 1 11 9.375M5.75 6H9.5v1.5H5.75zm0 5.25H9.5v1.5H5.75zm13.5 5.25V18H5.75v-1.5z"
  })));
};
export default SvgMenuSearchLine;